"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationsBell = void 0;
var React = require("react");
var NotificationsBell = function (_a) {
    var _b = _a.onClick, onClick = _b === void 0 ? function () { return undefined; } : _b, _c = _a.style, style = _c === void 0 ? {} : _c;
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", width: "24", height: "24", viewBox: "0 0 24 24", onClick: onClick, style: style },
        React.createElement("defs", null,
            React.createElement("path", { id: "NOTIFICATIONS_BELL_SVG_ICON_PATH", d: "M18.4 11.8c.8.6 1.6 1.2 1.6 2.2 0 2.8-6.1 3-8 3-1.9 0-8-.2-8-3 0-1 .8-1.6 1.6-2.2.8-.7 1.4-1.1 1.4-1.8V9c0-2.8 2.2-5 5-5s5 2.2 5 5v1c0 .7.6 1.1 1.4 1.8zm-3.5 6.1c-.4 1.2-1.5 2.1-2.9 2.1s-2.5-.9-2.9-2.1c1.1.1 2 .1 2.9.1.9 0 1.8 0 2.9-.1z" })),
        React.createElement("g", { fill: "none", fillRule: "evenodd" },
            React.createElement("mask", { id: "NOTIFICATIONS_BELL_SVG_ICON_MASK", fill: "#fff" },
                React.createElement("use", { xlinkHref: "#NOTIFICATIONS_BELL_SVG_ICON_PATH" })),
            React.createElement("g", { fill: "#00242D", mask: "url(#NOTIFICATIONS_BELL_SVG_ICON_MASK)" },
                React.createElement("path", { d: "M0 0h24v24H0z" })))));
};
exports.NotificationsBell = NotificationsBell;
//# sourceMappingURL=NotificationsBell.js.map